module.exports = __webpack_public_path__ + "static/media/ic_package_scan.192e2bd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ic_package_scan.png
// module id = 134
// module chunks = 0